<template>
  <div>
      <v-toolbar
        flat
        color="transparent"
        dense
      >
        <v-text-field
          v-model="searchText"
          label="Search"
          placeholder="Search users..."
          hide-details
          :append-outer-icon="'mdi-magnify'"
          @blur="search"
          clearable
          v-on:keyup.enter="search"
          @click:clear="searchText='';search()"
          @click:append-outer="search"
        />
        <v-spacer />
        <v-btn-toggle v-model="toggle_user_filter" @change="fetch">
          <v-btn
            :value="0"  
            flat
          >
            All
          </v-btn>
          <v-btn
            :value="true"  
            flat
          >
            Enabled
          </v-btn>
          <v-btn
            :value="false"  
            flat
          >
            Disabled
          </v-btn>
        </v-btn-toggle>
        <v-spacer />
        <v-btn
          dark
          color="success"
          round
          @click="addUser()"
        >
          <v-icon dark left>add</v-icon>
          New User
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout
          row wrap
        >
          <v-flex
            sm12
            md12
          >
            <v-card>
              <v-data-table
                :items="users"
                :headers="headers"
                :pagination.sync="pagination"
                :total-items="totalUsers"
                :rows-per-page-items="paginationStrings"
                :loading="loading"
                disable-initial-sort
              >
                <template slot="no-data">
                  <tr>
                    <td colspan="4">
                      <div style="text-align:center;padding:25px;">
                        <v-icon size="125px">find_in_page</v-icon>
                        <h3>No Results</h3>
                      </div>
                    </td>
                  </tr>
                </template>
                <template
                  slot="items"
                  slot-scope="props"
                >
                  <tr :class="{ 'disabled-user': !props.item.is_active }"
                        @click="edit(props.item.id)"
                        style="cursor:pointer;">
                    <td>
                      <div
                        v-if="props.item.first_name || props.item.last_name"
                        style="text-overflow: ellipsis;"
                      >
                        <b>{{ props.item.first_name }} {{ props.item.last_name }}</b>
                      </div>
                      <div
                        v-else
                        style="opacity: 0.5;"
                      >
                        [ No Name ]
                      </div>
                      <div
                        v-if="props.item.email"
                        style="text-overflow: ellipsis;overflow: hidden;"
                      >
                        {{ props.item.email }}
                      </div>
                    </td>
                    <td
                      style="text-overflow: ellipsis;overflow: hidden;"
                    >
                      {{ props.item.username }}
                    </td>
                    <td
                      style="text-overflow: ellipsis;overflow: hidden;"
                    >
                      {{ props.item.last_login ? convertToLocal(props.item.last_login) : 'Never' }}
                    </td>
                    <td class="justify-center layout px-0">
                      <v-icon
                        small
                        class="mr-2"
                        @click="edit(props.item.id)"
                      >
                        edit
                      </v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
  </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'
import User from '@/components/admin/users/User'

export default {
  name: 'UserList',
  components: {
    User
  },
  mixins: [
    pagination
  ],
  data () {
    return {
      users: [],
      edituser: null,
      editing: false,
      pagination: {},
      searchText: '',
      paginationStrings: [
        25, 50, 100
      ],
      headers: [
        { text: 'Name', value: 'last_name' },
        { text: 'Username', value: 'username' },
        { text: 'Last Login', value: 'last_login' },
        {
          text: 'Actions', align: 'center', sortable: false
        }
      ],
      loading: true,
      pagination: {
        page: this.$route.query.page || 1,
        descending: this.$route.query.descending || false,
        rowsPerPage: this.$route.query.rowsPerPage || 25,
        sortBy: this.$route.query.sortBy || null
      },
      toggle_user_filter: 0
    }
  },
  computed: {
    totalUsers () {
      return this.pagination.totalItems
    }
  },
  watch: {
    editing () {
      if (!this.editing) {
        this.edituser = null
        this.fetch()
      }
    }
  },
  methods: {
    fetch () {
      this.loading = true
      api.users.user.list({
        search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, pageNum: this.pagination.page, count: this.pagination.rowsPerPage,
        filter: this.toggle_user_filter !== 0 ? { is_active: this.toggle_user_filter} : {}
      })
        .then(data => {
          this.users = data.results
          this.pagination.page = data.page_number
          this.pagination.totalItems = data.count
          this.loading = false
          if (this.$route.params.id && !this.componentCreated) {
            this.editing = true
            this.edituser = this.$route.params.id
          }
          this.componentCreated = true
        })
    },
    addUser () {
      this.$router.push({name: 'OrgEditUser', params: { id: "new" } })
    },
    edit (user) {
      this.$router.push({name: 'OrgEditUser', params: { id: user } })
    }
  },
  created () {
    this.documentTitle('Users')
  }
}
</script>

<style>

.disabled-user {
  background: #FFCDD2;
}

.search-bar {
  margin-top: 1em;
}

table {
  margin-top: 1em;
}

</style>
